// ©2024 Austin App House. All rights reserved.
const isCanadaCountry = (country) => country?.value === 'CA' || country?.label === 'Canada';

const normalizeZipcodeInput = (value, country) => {
  if (!value) return value;

  if (isCanadaCountry(country)) {
    return value
      .toUpperCase()
      .replace(/[^A-Z0-9 ]/g, '')
      .replace(/\s+/g, ' ')
      .slice(0, 7);
  }

  return value.replace(/\D/g, '').slice(0, 5);
};

export default normalizeZipcodeInput;
